// alterado - revisado

import HARDCODE from '../../../business-const/HardCode/HardCode'

import {
    pesquisaList,
} from '../../../business-rules/List/ListService'

export const processaRegistrosDefaultIniciaisEsporteHobbyRisco = ( values, familiar ) => {

    if (familiar) {
        if (!values.familiaresProcessouRegistrosDefaultIniciaisEsporteHobbyRisco) {
            values.familiaresProcessouRegistrosDefaultIniciaisEsporteHobbyRisco = []
        }

        if (!values.esportesHobbiesRisco) {
            values.esportesHobbiesRisco = []
        }
        
        if (!pesquisaList(values.familiaresProcessouRegistrosDefaultIniciaisEsporteHobbyRisco, familiar).id) {

            values.familiaresProcessouRegistrosDefaultIniciaisEsporteHobbyRisco.push(
                {
                    id: familiar
                }
            )

            values.esportesHobbiesRisco.push(
                {
                    familiar: familiar,
                }
            )
        }
    }
}



const calculaEsporteHobbyRiscoTipoEsporteHobbyRiscoOutros = ( item ) => {
    if (item.tipoEsporteHobbyRisco !== HARDCODE.idTipoEsporteHobbyRiscoOutros) {
        item.tipoEsporteHobbyRiscoOutros = ''
    }
}

export const processaAlteracaoEsporteHobbyRiscoTipoEsporteHobbyRisco = ( item ) => {
    calculaEsporteHobbyRiscoTipoEsporteHobbyRiscoOutros(item)
}